import { render, staticRenderFns } from "./BookerOnboarding.vue?vue&type=template&id=0ba13cd7&scoped=true"
import script from "./BookerOnboarding.vue?vue&type=script&lang=js"
export * from "./BookerOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba13cd7",
  null
  
)

export default component.exports